import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.company;
const baseStateUpsert = createSelector([baseState], (state) => state.upsert);
const baseStateGet = createSelector([baseState], (state) => state.get);
const baseStateCode = createSelector([baseState], (state) => state.code);
const baseStateDelete = createSelector([baseState], (state) => state.delete);


export const myCompaniesSelector = createSelector([baseState], (state) => {
    return Object.values(state.data);
});

export const myCompaniesLoading = createSelector([baseStateGet, myCompaniesSelector], (state, companies) => {
    return state.status === ReducerStatuses.LOADING && companies.length === 0;
});

export const selectedCompanyForUpsert = createSelector([baseState], (state) => {
    return state.selected;
});
export const isEditingCompany = createSelector([baseState], (state) => {
    return !!state.selected;
});

export const upsertCompanyLoading = createSelector([baseStateUpsert], (state) => {
    return state.status === ReducerStatuses.LOADING;
});
export const upsertCompanyError = createSelector([baseStateUpsert], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});

export const companyCodeChangeLoading = createSelector([baseStateCode], (state) => {
    return state.status === ReducerStatuses.LOADING;
});

export const companyCodeChangeError = createSelector([baseStateCode], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});
export const companyDeleteLoading = createSelector([baseStateDelete], (state) => {
    return state.status === ReducerStatuses.LOADING;
});

export const companyDeleteError = createSelector([baseStateDelete], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});
export const companyDeleteSuccess = createSelector([baseStateDelete], (state) => {
    return state.status === ReducerStatuses.SUCCESS;
});